function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  r: 48,
  transform: "matrix(-1 0 0 1 49 49)",
  fill: "#D8D5D5",
  fillOpacity: 0.08
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  r: 48.5,
  transform: "matrix(-1 0 0 1 49 49)",
  stroke: "url(#paint0_linear)",
  strokeOpacity: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 49,
  r: 23.5,
  fill: "#D8D5D5",
  fillOpacity: 0.16,
  stroke: "#D8D5D5"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 49,
  r: 4,
  fill: "#F0F5F5"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 74.625,
  y1: 10.875,
  x2: 21.375,
  y2: 85.125,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#68DEDC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.664583,
  stopColor: "#D0DCDC",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.977083,
  stopColor: "#D8D5D5",
  stopOpacity: 0.1
})));

function SvgCirclePointer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePointer);
export default __webpack_public_path__ + "static/media/CirclePointer.3faa033a.svg";
export { ForwardRef as ReactComponent };